exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".wrapper[data-v-3d7a37a3]{width:435px;margin:0 auto}.line[data-v-3d7a37a3]{margin:0 auto;margin-right:5rem;display:flex;justify-content:flex-end;align-items:center}.blockRow[data-v-3d7a37a3]{padding:.25rem}.quota[data-v-3d7a37a3]{border:1px dashed #333}.completionStats[data-v-3d7a37a3]{margin-top:1rem;justify-content:space-around}.completionStats h2[data-v-3d7a37a3]{margin-top:.25rem;margin-bottom:.25rem}.fraction[data-v-3d7a37a3]{font-size:.875rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-3d7a37a3&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./dev/src/views/LineView.vue
// module id = ./node_modules/css-loader/index.js?minimize!./node_modules/vue-loader/lib/style-rewriter.js?id=data-v-3d7a37a3&scoped=true!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./dev/src/views/LineView.vue
// module chunks = 0